import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ImageUpload.css';
import SimpleButton from 'components/shared/button/SimpleButton';
import plusIconPng from 'images/plus-icon.png';
import removeIconPng from 'images/remove.png';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import FullScreenImageViewer from 'components/shared/image-upload/FullScreenImageViewer';
import { validateFile } from 'services/utils/files-util';
class ImageUpload extends Component {
  static propTypes = {
    extensions: PropTypes.arrayOf(PropTypes.string),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        preview: PropTypes.string,
        file: PropTypes.object,
      })
    ),
    min: PropTypes.number,
    max: PropTypes.number,
    notes: PropTypes.string,
    readOnly: PropTypes.bool,
    onRemove: PropTypes.func,
    onUpload: PropTypes.func,
    multiple: PropTypes.bool,
  };

  static defaultProps = {
    extensions: [],
    images: [],
    min: 0,
    max: 0,
    notes: null,
    multiple: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      imageIndexToRemove: 0,
      fullScreenUrl: '',
      showConfirmation: false,
      showFullScreen: false,
    };
  }

  handleAddPhotoClick = () => {
    this.fileUpload.click();
  };

  handleFullScreenOpen = (url, event) => {
    event.preventDefault();
    this.setState({
      fullScreenUrl: url,
      showFullScreen: true,
    });
  };

  handleFullScreenClose = () => {
    this.setState({
      showFullScreen: false,
    });
  };

  handleNewImagesUpload = (files) => {
    let newFiles = [];
    for (let i = 0; i < files.length; i++) {
      if (validateFile(files.item(i).name, this.props.extensions)) {
        newFiles.push(files.item(i));
      }
    }

    if (this.props.max > 0) {
      // Remove extra files uploaded
      newFiles = newFiles.slice(0, this.props.max);
    }

    // Clear input to allow to upload the same file twice
    this.fileUpload.value = '';

    this.props.onUpload(newFiles);
  };

  handleRemoveRequest(index, event) {
    event.preventDefault();
    this.setState({
      imageIndexToRemove: index,
      showConfirmation: true,
    });
  }

  handleRemove = (result) => {
    if (result) {
      this.props.onRemove(this.state.imageIndexToRemove);
    }
    this.setState({
      imageIndexToRemove: 0,
      showConfirmation: false,
    });
  };

  render() {
    const buttonLabel = this.props.multiple ? 'Add Photos' : 'Add Photo';
    let minMaxSpan = null;
    if (this.props.min > 0) {
      minMaxSpan = 'Minimum of ' + this.props.min;
    }

    if (this.props.max > 0) {
      if (this.props.min > 0) {
        minMaxSpan += ', maximum of ' + this.props.max;
      } else {
        minMaxSpan = 'Maximum of ' + this.props.max;
      }
    }

    if (minMaxSpan !== null) {
      minMaxSpan += '.';
    }

    return (
      <div className="image-upload">
        <div className="preview-container">
          {this.props.images.map((image, index) => {
            if (image.preview !== undefined && image.preview !== null) {
              return this.getImageDiv(index, image.preview, {
                show: this.props.readOnly && image.url !== null,
                url: image.url,
              });
            } else if (image.url !== undefined && image.url !== null) {
              return this.getImageDiv(index, image.url, {
                show: this.props.readOnly,
                url: image.url,
              });
            } else if (image.file !== undefined && image.file !== null) {
              return this.getImageDiv(index, image.file.img);
            } else {
              return null;
            }
          })}

          <ConfirmationModal
            show={this.state.showConfirmation}
            message="Are you sure?"
            onHide={this.handleRemove}
          />
        </div>

        {!this.props.readOnly ? (
          <div className="image-upload-button-container">
            <div>
              <SimpleButton
                className="add-photos-button"
                disabled={
                  this.props.max > 0
                    ? this.props.images.length >= this.props.max
                    : false
                }
                img={plusIconPng}
                label={buttonLabel}
                onClick={this.handleAddPhotoClick}
              />
            </div>

            {(minMaxSpan !== null || this.props.notes !== null) && (
              <div>
                <ul>
                  {this.props.notes !== null && (
                    <li>
                      <span>{this.props.notes}</span>
                    </li>
                  )}
                  {minMaxSpan !== null ? (
                    <li>
                      <span>{minMaxSpan}</span>
                    </li>
                  ) : null}
                </ul>
              </div>
            )}

            <input
              accept={
                this.props.extensions.length > 0
                  ? this.props.extensions
                  : 'image/*'
              }
              multiple={this.props.multiple}
              ref={(input) => {
                this.fileUpload = input;
              }}
              style={{ display: 'none' }}
              type="file"
              onChange={(event) => {
                event.preventDefault();
                this.handleNewImagesUpload(event.target.files);
              }}
            />
          </div>
        ) : null}

        <FullScreenImageViewer
          show={this.state.showFullScreen}
          url={this.state.fullScreenUrl}
          onClose={this.handleFullScreenClose}
        />
      </div>
    );
  }

  /**
   *
   * @param index
   * @param source
   * @param fullScreenInfo  - { show: boolean, url: string }
   * @return {*}
   */
  getImageDiv(index, source, fullScreenInfo = null) {
    if (fullScreenInfo !== null && fullScreenInfo.show) {
      return (
        <div key={index}>
          <img
            className="img-full-screen"
            src={source}
            alt={''}
            onClick={this.handleFullScreenOpen.bind(this, fullScreenInfo.url)}
          />
        </div>
      );
    } else {
      return (
        <div key={index}>
          <img src={source} alt={''} />
          {this.props.onRemove !== undefined && (
            <div className="remove-container">
              <img
                src={removeIconPng}
                alt=""
                onClick={this.handleRemoveRequest.bind(this, index)}
              />
            </div>
          )}
        </div>
      );
    }
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/shared/image-upload/ImageUpload.js